import styled from 'styled-components'
import { blue as blueColor, mildGray, lightGray } from '../../styles/variables.js'

const FloatingButtonContainer = styled.div`
  position: fixed;
  bottom: 32px;
  right: 32px;
`

const FloatingButton = styled.div`
  width: 70px;
  height: 70px;

  border-radius: 50%;
  box-shadow: 0 6px 10px 0 #666;
  transition: all 0.1s ease-in-out;

  background: ${ blueColor };
  color: white;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  font-size: 26px;

  z-index: 2;

  ${({ disabled }) => disabled ? `
      background: ${mildGray};
      color: white;
      cursor: not-allowed;
  ` : ''}

  &:hover {
    box-shadow: 0 6px 14px 0 #666;
    transform: scale(1.05);
  }
`

const AdditionalContainer = styled.div`
  display: flex;
  flex-direction: row;

  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: -1;
  opacity: 0;

  transition: all 0.2s ease-in-out;

  &.visible {
    right: 90px;
    opacity: 1;
  }
`

const AdditionalButton = styled.div`
  width: 50px;
  height: 50px;

  border-radius: 50%;
  box-shadow: 0 6px 10px 0 #666;
  transition: all 0.1s ease-in-out;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  font-size: 20px;
  background: ${ lightGray };
  color: white;
  cursor: pointer;

  &:hover {
    box-shadow: 0 6px 14px 0 #666;
    transform: scale(1.05);
    background: ${ blueColor };
  }
`

export default {
  FloatingButtonContainer,
  FloatingButton,
  AdditionalContainer,
  AdditionalButton,
}
